import axios from "axios";
import { getCookieValue } from "./getCookieValue";

const axiosClient = axios.create({
    headers: {
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCookieValue("XSRF-TOKEN"),
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
        },
    },
});

export default axiosClient;
